// @ts-nocheck
export const tagLimitRule = () => ({
  name: 'tag-limit',
  validate(cartState = null, mutation = null) {
    return {
      allowed: true,
      modifiedMutation: mutation,
    };
  },
});
